<template>
  <Section :content="projects" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionProjects',
  components: {
    Section,
  },
  data() {
    return {
      
    }
  },
  computed: {
    projects() {
      var path = this.$route.path;
      var learnMoreLink = '/projects';
      if (path === '/projects') {
        learnMoreLink = '';
      }
      return { 
        eyebrow: 'Pods',
        eyebrowIcon: 'trinapp_projects.png',
        headline: 'Construction Project and Building digital twins',
        paragraphs: [
          'Create and Access Digital Twins of Buildings and the Projects to construct them. Allocate access to individuals, or the individuals in a group or company.', 
          'The digital twin of the building is continuously created throughout the construction process, eliminating expensive handovers.'
        ],
        id: 'projects',
        image: 'Project-w-collaborators-web.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        learnMoreLink: learnMoreLink,
      }
    } 
  }
};
</script>
